import { Switch } from 'antd';
import styled from 'styled-components';

export const StyledSwitch = styled(Switch)``;
